import { createRoot } from 'react-dom/client';
import TeacherStatusController from './TeacherStatsController.js';

/* global teacherStats, isTeacher, teacherNameEncoded, liveProposals, teacherProfileUrl, schoolState,
    teacherProfilePhotoURL, schoolName, schoolCityAndState, teacherPossessiveScreenName, schoolURL */ // All defined as pageSpecificJavascripts

$(function () {
    const root = createRoot(document.getElementById('content'));

    root.render(
        <TeacherStatusController data={teacherStats} isTeacher={isTeacher} teacherName={teacherNameEncoded} liveProposals={liveProposals} teacherProfileUrl={teacherProfileUrl}
            teacherProfilePhotoURL={teacherProfilePhotoURL} schoolName={schoolName} schoolCityAndState={schoolCityAndState} schoolState={schoolState} schoolURL={schoolURL} teacherPossessiveScreenName={teacherPossessiveScreenName}/>
    );
});
